import { Inject, Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { MetaTagInput } from './metataginput';


@Injectable({
    providedIn: 'root'
})
export class MetaService {

    frontendUrl = window.location.origin;

    constructor(private _meta: Meta, private _router: Router, @Inject(DOCUMENT) private document: Document, private titleService: Title,) { }

    settingUpOgUrl() {
        this._meta.updateTag({ property: 'og:url', content: this.frontendUrl + this._router.url });
        this.setCanonicalUrl(this.frontendUrl + this._router.url);
        this.indexedBySearchEngineAndFollowLinks();
    }

    settingUpOgImage(imageUrl: string) {
        this._meta.updateTag({ property: 'og:image', content: (imageUrl) as string });
    }

    settingUpDescription(description: string) {
        this._meta.updateTag({ name: 'description', content: description });
    }

    settingUpOgHomeUrl(url: string) {
        this._meta.updateTag({ property: 'og:url', content: url });
    }

    settingUpOgLogoImage(logoUrl: string) {
        this._meta.updateTag({ property: 'og:image', content: logoUrl });
    }

    //TODO make a table into database with keywords and pass it into content
    settingUpKeywordsForGoogleAds(keywords: string) {
        this._meta.updateTag({ name: 'keywords', content: keywords });
    }

    indexedBySearchEngineAndFollowLinks() {
        this._meta.updateTag({ name: 'robots', content: 'index, follow' });
    }

    setCanonicalUrl(url: string) {
        let link: HTMLLinkElement = this.document.querySelector("link[rel='canonical']")
            || this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute('href', url);
        if (!link.parentNode) {
            this.document.head.appendChild(link);
        }
    }

    setMetaTags(tags: MetaTagInput): void {
        if (tags.ogTitle) {
            this.titleService.setTitle(tags.ogTitle);
            this._meta.updateTag({ property: 'og:title', content: tags.ogTitle });
        }

        if (tags.ogDescription) {
            this._meta.updateTag({ name: 'description', content: tags.ogDescription });
            this._meta.updateTag({ property: 'og:description', content: tags.ogDescription });
        }

        if (tags.ogImage) {
            this._meta.updateTag({ property: 'og:image', content: tags.ogImage });
        }

        if (tags.keywords) {
            this._meta.updateTag({ name: 'keywords', content: tags.keywords });
        }

        const fullUrl = tags.ogUrl || (this.frontendUrl + this._router.url);
        this._meta.updateTag({ property: 'og:url', content: fullUrl });
        this.setCanonicalUrl(fullUrl);

        this.indexedBySearchEngineAndFollowLinks();
    }



    updateMetaTags(metaData: MetaTagInput) {
        if (metaData.ogTitle) {
            this.titleService.setTitle(metaData.ogTitle);
            this._meta.updateTag({ property: 'og:title', content: metaData.ogTitle });
        }

        if (metaData.ogDescription) {
            this._meta.updateTag({ name: 'description', content: metaData.ogDescription });
            this._meta.updateTag({ property: 'og:description', content: metaData.ogDescription });
        }

        if (metaData.ogImage) {
            this._meta.updateTag({ property: 'og:image', content: metaData.ogImage });
        }

        if (metaData.ogUrl) {
            this._meta.updateTag({ property: 'og:url', content: metaData.ogUrl });
        }

        if (metaData.keywords) {
            this._meta.updateTag({ name: 'keywords', content: metaData.keywords });
        }

        const fullUrl = metaData.ogUrl || (this.frontendUrl + this._router.url);
        this._meta.updateTag({ property: 'og:url', content: fullUrl });
        this.setCanonicalUrl(fullUrl);
        this.indexedBySearchEngineAndFollowLinks();
    }



}
